import assessmentReducer from './assessmentReducer';
import { reducer as api } from 'redux-json-api';

export default {
  assessmentReducer,
  api
};
